import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

export default function Delete({ action, variables, setOpenVariable }) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ARRAY.';
  const [value, setValue] = useState();

  useEffect(() => {
    if (!action.fields['filter']) {
      action.fields['filter'] = { type: 'RADIO', value: options.defaultValue, isRequired: true };
    }
    setValue(action.fields['filter'].value);
  }, [action]);

  const handleChange = (event) => {
    setValue(event.target.value);
    action.fields['filter'].value = event.target.value;
    action.fields['index'].value = '';
  };
  const options = {
    radioButtons: {
      data: [
        {
          value: 'filterIndex',
          label: label + 'FILTER-INDEX',
        },
        {
          value: 'filterValue',
          label: label + 'FILTER-VALUE'
        }
      ],
      defaultValue: 'filterIndex'
    }
  };
  return (
    <div>
      <div className="form-element">
        {t(label + 'ARRAY-VARIABLE')}
        <TextInput action={action} inputName="variable" variables={variables}
          setOpenVariable={setOpenVariable} isRequired={true} include={['array']} fieldType="array" displayName={t(label + 'ARRAY-VARIABLE')} />
      </div>
      <div className="form-element">
        {t(label + 'FILTER')}
        <RadioGroup value={value ? value : options.radioButtons.defaultValue} onChange={handleChange}>
          {options.radioButtons.data.map((item, itemI) =>
            <FormControlLabel
              key={itemI} value={item.value}
              control={<Radio color='#C4C4C4' />}
              label={t(item.label)}
              labelPlacement="end"
              size="small"
            />
          )}
        </RadioGroup>
      </div>
      <div className="form-element">
        <TextInput action={action} inputName="index" variables={variables}
          setOpenVariable={setOpenVariable} refresh={value}
          fieldType={value === 'filterValue' ? 'string' : 'number'} displayName={t(label + 'FILTER')}
        />
      </div>
      <div className="form-element">
        {t('CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE')}
        <VariablePicker action={action} inputName="set"
          variables={variables} setOpenVariable={setOpenVariable}
        />
      </div>
    </div>
  );
}
